// FluffOff — AJAX for the cart drawer's Protection checkbox + Cross-sell form.
// Loaded once on every page (document-level delegation) so it catches the
// dynamically-rendered cart drawer controls without a full page reload.
(function () {
  if (window.__foCartAjax) return;
  window.__foCartAjax = true;

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset && c.dataset.sectionId) ids.push(c.dataset.sectionId);
    });
    return ids;
  }

  function refreshCart(added) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = {
        resource: cart,
        sourceId: 'fo-cart',
        data: { source: 'fo-cart', sections: added ? added.sections : null, itemCount: cart.item_count }
      };
      document.dispatchEvent(ev);
    });
  }

  // --- Cross-sell "+ Ajouter" forms (add only) ---
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('fo-xsell__card')) return;
    e.preventDefault();

    var input = form.querySelector('input[name="id"]');
    if (!input) { form.submit(); return; }

    var fd = new FormData();
    fd.append('id', input.value);
    fd.append('quantity', '1');
    var ids = sectionIds();
    if (ids.length) fd.append('sections', ids.join(','));

    var btn = form.querySelector('button');
    if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }

    fetch('/cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (added) {
        if (added && added.status) { window.location = '/cart'; return; }
        return refreshCart(added);
      })
      .catch(function () { form.submit(); });
  });

  // --- Protection checkbox (add when checked, remove when unchecked) ---
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.classList || !cb.classList.contains('fo-protect__check')) return;
    var wrap = cb.closest('.fo-protect');
    if (!wrap) return;
    var id = wrap.getAttribute('data-protect-id');
    if (!id) return;

    cb.disabled = true;
    wrap.style.opacity = '0.6';

    var ids = sectionIds();
    var sectionsParam = ids.length ? ids.join(',') : null;

    var req;
    if (cb.checked) {
      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', '1');
      if (sectionsParam) fd.append('sections', sectionsParam);
      req = fetch('/cart/add', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
    } else {
      var body = { id: String(id), quantity: 0 };
      if (sectionsParam) body.sections = sectionsParam;
      req = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
    }

    req
      .then(function (r) { return r.json(); })
      .then(function (res) {
        return refreshCart(res && res.sections ? res : null);
      })
      .catch(function () { window.location = '/cart'; });
  });
})();
